// extracted by mini-css-extract-plugin
module.exports = {"amount_card":"styles_amount_card__wTAj_","amount_card_selected":"styles_amount_card_selected__KZPSg"};